(() => {
  const root = document.querySelector('.dewalt-system-builder');
  if (!root) return;

  /* SMART ENGINE - MOBILE OVERFLOW FIX
     Shopify Inbox riscrive dinamicamente la propria larghezza.
     Su questa pagina forziamo chat + footer entro il viewport reale. */
  function fixSmartEngineMobileOverflow() {
    if (window.innerWidth > 749) return;
    if (!document.querySelector('.dewalt-system-builder')) return;

    const viewportWidth = document.documentElement.clientWidth;

    document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
    document.body.style.setProperty('overflow-x', 'hidden', 'important');

    const chat = document.querySelector('shopify-chat');
    if (chat) {
      const px = `${viewportWidth}px`;
      if (chat.style.getPropertyValue('width') !== px) {
        chat.style.setProperty('position', 'fixed', 'important');
        chat.style.setProperty('width', px, 'important');
        chat.style.setProperty('max-width', px, 'important');
        chat.style.setProperty('left', '0', 'important');
        chat.style.setProperty('right', '0', 'important');
      }
    }

    const footer = document.querySelector('.footer__blocks-wrapper');
    if (footer) {
      footer.style.setProperty('display', 'block', 'important');
      footer.style.setProperty('width', '100%', 'important');
      footer.style.setProperty('max-width', '100%', 'important');
    }

    document.querySelectorAll('.footer-block.grid__item').forEach((el) => {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('margin-left', '0', 'important');
      el.style.setProperty('margin-right', '0', 'important');
    });

    const social = document.querySelector('.footer__list-social');
    if (social) {
      social.style.setProperty('width', '100%', 'important');
      social.style.setProperty('max-width', '100%', 'important');
      social.style.setProperty('margin-left', '0', 'important');
      social.style.setProperty('margin-right', '0', 'important');
    }
  }

  fixSmartEngineMobileOverflow();
  window.addEventListener('load', fixSmartEngineMobileOverflow);
  window.addEventListener('resize', fixSmartEngineMobileOverflow);

  const mobileOverflowObserver = new MutationObserver(() => {
    window.requestAnimationFrame(fixSmartEngineMobileOverflow);
  });

  mobileOverflowObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  const apiBase = (root.dataset.apiBase || 'https://kit-builder-api.onrender.com').replace(/\/$/, '');

  const locale = (root.dataset.locale || document.documentElement.lang || 'it').toLowerCase().split('-')[0];
  const I18N = {
    it: {
      apiError:'Errore API: {status}', timeoutData:'Timeout caricamento dati. Riprova tra qualche secondo.', timeoutSmart:'Smart Engine sta impiegando più del previsto. Riprova tra qualche secondo.',
      noMachine:'Nessuna macchina selezionata', oneMachine:'1 macchina selezionata', manyMachines:'{count} macchine selezionate',
      noBattery:'Nessuna batteria o caricabatterie selezionato', oneItem:'1 articolo selezionato', manyItems:'{count} articoli selezionati',
      noTstak:'Nessun prodotto TSTAK selezionato', oneTstak:'1 prodotto TSTAK selezionato', manyTstak:'{count} prodotti TSTAK selezionati',
      noAccessory:'Nessun accessorio selezionato', oneAccessory:'1 accessorio selezionato', manyAccessories:'{count} accessori selezionati',
      recalculating:'Configurazione modificata. Ricalcolo automatico in corso...', noProducts:'Nessun prodotto selezionato.', includedKit:'Incluso nel kit consigliato',
      addBusy:'AGGIUNGO AL CARRELLO...', addFail:'Impossibile aggiungere i prodotti al carrello.', available:'Disponibile', unavailable:'Non disponibile',
      noAccessoriesNow:'Nessun accessorio disponibile al momento.', noMachineDot:'Nessuna macchina selezionata.', noBatteryDot:'Nessuna batteria aggiunta.',
      noTstakDot:'Nessun prodotto TSTAK aggiunto.', noAccessoryDot:'Nessun accessorio aggiunto.', customerSelected:'Configurazione cliente selezionata.',
      waitingSmart:'In attesa dello step Smart Engine.', customerPrice:'Prezzo configurazione cliente', verifiedPrice:'Prezzo totale verificato', provisionalPrice:'Prezzo totale provvisorio',
      vat:'IVA inclusa', optAvailable:'✓ Soluzione ottimizzata disponibile', configAvailable:'✓ Configurazione disponibile', incomplete:'⚠ Disponibilità incompleta',
      recommended:'Soluzione consigliata Smart Engine', verified:'Configurazione verificata',
      better:'Smart Engine ha trovato una soluzione più conveniente. Risparmio stimato {saving}.{extra}',
      extraSentence:' La soluzione consigliata include anche componenti aggiuntivi rispetto alla configurazione scelta.',
      customerConfig:'Configurazione scelta dal cliente', useThis:'Usa questa configurazione', useRecommended:'Usa soluzione consigliata',
      extraTitle:'Componenti aggiuntivi inclusi nella soluzione consigliata', extraSub:'Il kit contiene questi articoli in più rispetto alla configurazione scelta.',
      saving:'Risparmio stimato', customerTotal:'Totale configurazione cliente', verifiedTotal:'Totale configurazione verificata',
      loadingMachines:'Caricamento macchine...', invalidMachines:'Formato dati macchine non valido.', loadingTstak:'Caricamento prodotti TSTAK...',
      loadingAccessories:'Caricamento accessori...', analyzing:'Analisi configurazione in corso...', completeSmart:'Completa prima lo step Smart Engine.',
      noValid:'Nessun prodotto valido da aggiungere al carrello.', cartErr:'Errore durante l’aggiunta al carrello.'
    },
    fr: {
      apiError:'Erreur API : {status}', timeoutData:'Délai de chargement dépassé. Réessayez dans quelques secondes.', timeoutSmart:'Smart Engine prend plus de temps que prévu. Réessayez dans quelques secondes.',
      noMachine:'Aucune machine sélectionnée', oneMachine:'1 machine sélectionnée', manyMachines:'{count} machines sélectionnées',
      noBattery:'Aucune batterie ni chargeur sélectionné', oneItem:'1 article sélectionné', manyItems:'{count} articles sélectionnés',
      noTstak:'Aucun produit TSTAK sélectionné', oneTstak:'1 produit TSTAK sélectionné', manyTstak:'{count} produits TSTAK sélectionnés',
      noAccessory:'Aucun accessoire sélectionné', oneAccessory:'1 accessoire sélectionné', manyAccessories:'{count} accessoires sélectionnés',
      recalculating:'Configuration modifiée. Recalcul automatique en cours...', noProducts:'Aucun produit sélectionné.', includedKit:'Inclus dans le kit recommandé',
      addBusy:'AJOUT AU PANIER...', addFail:'Impossible d’ajouter les produits au panier.', available:'Disponible', unavailable:'Indisponible',
      noAccessoriesNow:'Aucun accessoire disponible pour le moment.', noMachineDot:'Aucune machine sélectionnée.', noBatteryDot:'Aucune batterie ajoutée.',
      noTstakDot:'Aucun produit TSTAK ajouté.', noAccessoryDot:'Aucun accessoire ajouté.', customerSelected:'Configuration client sélectionnée.',
      waitingSmart:'En attente de l’étape Smart Engine.', customerPrice:'Prix de la configuration client', verifiedPrice:'Prix total vérifié', provisionalPrice:'Prix total provisoire',
      vat:'TVA incluse', optAvailable:'✓ Solution optimisée disponible', configAvailable:'✓ Configuration disponible', incomplete:'⚠ Disponibilité incomplète',
      recommended:'Solution recommandée Smart Engine', verified:'Configuration vérifiée',
      better:'Smart Engine a trouvé une solution plus avantageuse. Économie estimée {saving}.{extra}',
      extraSentence:' La solution recommandée comprend également des composants supplémentaires par rapport à la configuration choisie.',
      customerConfig:'Configuration choisie par le client', useThis:'Utiliser cette configuration', useRecommended:'Utiliser la solution recommandée',
      extraTitle:'Composants supplémentaires inclus dans la solution recommandée', extraSub:'Le kit contient ces articles en plus par rapport à la configuration choisie.',
      saving:'Économie estimée', customerTotal:'Total configuration client', verifiedTotal:'Total configuration vérifiée',
      loadingMachines:'Chargement des machines...', invalidMachines:'Format des données machines non valide.', loadingTstak:'Chargement des produits TSTAK...',
      loadingAccessories:'Chargement des accessoires...', analyzing:'Analyse de la configuration en cours...', completeSmart:'Terminez d’abord l’étape Smart Engine.',
      noValid:'Aucun produit valide à ajouter au panier.', cartErr:'Erreur lors de l’ajout au panier.'
    },
    de: {
      apiError:'API-Fehler: {status}', timeoutData:'Zeitüberschreitung beim Laden. Bitte in einigen Sekunden erneut versuchen.', timeoutSmart:'Smart Engine benötigt länger als erwartet. Bitte in einigen Sekunden erneut versuchen.',
      noMachine:'Keine Maschine ausgewählt', oneMachine:'1 Maschine ausgewählt', manyMachines:'{count} Maschinen ausgewählt',
      noBattery:'Kein Akku oder Ladegerät ausgewählt', oneItem:'1 Artikel ausgewählt', manyItems:'{count} Artikel ausgewählt',
      noTstak:'Kein TSTAK Produkt ausgewählt', oneTstak:'1 TSTAK Produkt ausgewählt', manyTstak:'{count} TSTAK Produkte ausgewählt',
      noAccessory:'Kein Zubehör ausgewählt', oneAccessory:'1 Zubehörartikel ausgewählt', manyAccessories:'{count} Zubehörartikel ausgewählt',
      recalculating:'Konfiguration geändert. Automatische Neuberechnung läuft...', noProducts:'Keine Produkte ausgewählt.', includedKit:'Im empfohlenen Kit enthalten',
      addBusy:'WIRD ZUM WARENKORB HINZUGEFÜGT...', addFail:'Produkte konnten nicht zum Warenkorb hinzugefügt werden.', available:'Verfügbar', unavailable:'Nicht verfügbar',
      noAccessoriesNow:'Derzeit kein Zubehör verfügbar.', noMachineDot:'Keine Maschine ausgewählt.', noBatteryDot:'Kein Akku hinzugefügt.',
      noTstakDot:'Kein TSTAK Produkt hinzugefügt.', noAccessoryDot:'Kein Zubehör hinzugefügt.', customerSelected:'Kundenkonfiguration ausgewählt.',
      waitingSmart:'Warten auf den Smart-Engine-Schritt.', customerPrice:'Preis Kundenkonfiguration', verifiedPrice:'Geprüfter Gesamtpreis', provisionalPrice:'Vorläufiger Gesamtpreis',
      vat:'inkl. MwSt.', optAvailable:'✓ Optimierte Lösung verfügbar', configAvailable:'✓ Konfiguration verfügbar', incomplete:'⚠ Verfügbarkeit unvollständig',
      recommended:'Empfohlene Smart-Engine-Lösung', verified:'Geprüfte Konfiguration',
      better:'Smart Engine hat eine günstigere Lösung gefunden. Geschätzte Ersparnis {saving}.{extra}',
      extraSentence:' Die empfohlene Lösung enthält zusätzliche Komponenten gegenüber der gewählten Konfiguration.',
      customerConfig:'Vom Kunden gewählte Konfiguration', useThis:'Diese Konfiguration verwenden', useRecommended:'Empfohlene Lösung verwenden',
      extraTitle:'Zusätzliche Komponenten in der empfohlenen Lösung', extraSub:'Das Kit enthält diese zusätzlichen Artikel gegenüber der gewählten Konfiguration.',
      saving:'Geschätzte Ersparnis', customerTotal:'Gesamt Kundenkonfiguration', verifiedTotal:'Gesamt geprüfte Konfiguration',
      loadingMachines:'Maschinen werden geladen...', invalidMachines:'Ungültiges Maschinendatenformat.', loadingTstak:'TSTAK Produkte werden geladen...',
      loadingAccessories:'Zubehör wird geladen...', analyzing:'Konfiguration wird analysiert...', completeSmart:'Bitte zuerst den Smart-Engine-Schritt abschließen.',
      noValid:'Keine gültigen Produkte für den Warenkorb.', cartErr:'Fehler beim Hinzufügen zum Warenkorb.'
    },
    es: {
      apiError:'Error de API: {status}', timeoutData:'Tiempo de carga agotado. Inténtalo de nuevo en unos segundos.', timeoutSmart:'Smart Engine está tardando más de lo previsto. Inténtalo de nuevo en unos segundos.',
      noMachine:'Ninguna máquina seleccionada', oneMachine:'1 máquina seleccionada', manyMachines:'{count} máquinas seleccionadas',
      noBattery:'Ninguna batería ni cargador seleccionado', oneItem:'1 artículo seleccionado', manyItems:'{count} artículos seleccionados',
      noTstak:'Ningún producto TSTAK seleccionado', oneTstak:'1 producto TSTAK seleccionado', manyTstak:'{count} productos TSTAK seleccionados',
      noAccessory:'Ningún accesorio seleccionado', oneAccessory:'1 accesorio seleccionado', manyAccessories:'{count} accesorios seleccionados',
      recalculating:'Configuración modificada. Recalculando automáticamente...', noProducts:'Ningún producto seleccionado.', includedKit:'Incluido en el kit recomendado',
      addBusy:'AÑADIENDO AL CARRITO...', addFail:'No se pudieron añadir los productos al carrito.', available:'Disponible', unavailable:'No disponible',
      noAccessoriesNow:'No hay accesorios disponibles en este momento.', noMachineDot:'Ninguna máquina seleccionada.', noBatteryDot:'Ninguna batería añadida.',
      noTstakDot:'Ningún producto TSTAK añadido.', noAccessoryDot:'Ningún accesorio añadido.', customerSelected:'Configuración del cliente seleccionada.',
      waitingSmart:'Esperando el paso Smart Engine.', customerPrice:'Precio de la configuración del cliente', verifiedPrice:'Precio total verificado', provisionalPrice:'Precio total provisional',
      vat:'IVA incluido', optAvailable:'✓ Solución optimizada disponible', configAvailable:'✓ Configuración disponible', incomplete:'⚠ Disponibilidad incompleta',
      recommended:'Solución recomendada Smart Engine', verified:'Configuración verificada',
      better:'Smart Engine ha encontrado una solución más conveniente. Ahorro estimado {saving}.{extra}',
      extraSentence:' La solución recomendada incluye componentes adicionales respecto a la configuración elegida.',
      customerConfig:'Configuración elegida por el cliente', useThis:'Usar esta configuración', useRecommended:'Usar solución recomendada',
      extraTitle:'Componentes adicionales incluidos en la solución recomendada', extraSub:'El kit contiene estos artículos adicionales respecto a la configuración elegida.',
      saving:'Ahorro estimado', customerTotal:'Total configuración del cliente', verifiedTotal:'Total configuración verificada',
      loadingMachines:'Cargando máquinas...', invalidMachines:'Formato de datos de máquinas no válido.', loadingTstak:'Cargando productos TSTAK...',
      loadingAccessories:'Cargando accesorios...', analyzing:'Analizando configuración...', completeSmart:'Completa primero el paso Smart Engine.',
      noValid:'Ningún producto válido para añadir al carrito.', cartErr:'Error al añadir al carrito.'
    },
    en: {
      apiError:'API error: {status}', timeoutData:'Data loading timed out. Please try again in a few seconds.', timeoutSmart:'Smart Engine is taking longer than expected. Please try again in a few seconds.',
      noMachine:'No tool selected', oneMachine:'1 tool selected', manyMachines:'{count} tools selected',
      noBattery:'No battery or charger selected', oneItem:'1 item selected', manyItems:'{count} items selected',
      noTstak:'No TSTAK product selected', oneTstak:'1 TSTAK product selected', manyTstak:'{count} TSTAK products selected',
      noAccessory:'No accessory selected', oneAccessory:'1 accessory selected', manyAccessories:'{count} accessories selected',
      recalculating:'Configuration changed. Recalculating automatically...', noProducts:'No product selected.', includedKit:'Included in the recommended kit',
      addBusy:'ADDING TO CART...', addFail:'Unable to add products to cart.', available:'Available', unavailable:'Unavailable',
      noAccessoriesNow:'No accessories are currently available.', noMachineDot:'No tool selected.', noBatteryDot:'No battery added.',
      noTstakDot:'No TSTAK product added.', noAccessoryDot:'No accessory added.', customerSelected:'Customer configuration selected.',
      waitingSmart:'Waiting for the Smart Engine step.', customerPrice:'Customer configuration price', verifiedPrice:'Verified total price', provisionalPrice:'Provisional total price',
      vat:'VAT included', optAvailable:'✓ Optimized solution available', configAvailable:'✓ Configuration available', incomplete:'⚠ Incomplete availability',
      recommended:'Smart Engine recommended solution', verified:'Verified configuration',
      better:'Smart Engine found a better-value solution. Estimated saving {saving}.{extra}',
      extraSentence:' The recommended solution also includes additional components compared with your chosen configuration.',
      customerConfig:'Customer selected configuration', useThis:'Use this configuration', useRecommended:'Use recommended solution',
      extraTitle:'Additional components included in the recommended solution', extraSub:'The kit contains these extra items compared with your chosen configuration.',
      saving:'Estimated saving', customerTotal:'Customer configuration total', verifiedTotal:'Verified configuration total',
      loadingMachines:'Loading tools...', invalidMachines:'Invalid tool data format.', loadingTstak:'Loading TSTAK products...',
      loadingAccessories:'Loading accessories...', analyzing:'Analyzing configuration...', completeSmart:'Complete the Smart Engine step first.',
      noValid:'No valid product to add to cart.', cartErr:'Error while adding to cart.'
    }
  };
  const dict = I18N[locale] || I18N.it;
  const t = (key, vars = {}) => {
    let s = dict[key] ?? I18N.it[key] ?? key;
    Object.entries(vars).forEach(([k,v]) => { s = s.replaceAll(`{${k}}`, String(v)); });
    return s;
  };

  const els = {
    machines: document.getElementById('dkb-machines'),
    selection: document.getElementById('dkb-selection'),
    solution: document.getElementById('dkb-solution'),
    add: document.getElementById('dkb-add-to-cart'),

    continueTop: document.getElementById('dkb-continue-top'),
    continueBottom: document.getElementById('dkb-continue-bottom'),
    selectedTop: document.getElementById('dkb-selected-top'),
    heroMachines: document.getElementById('dsb-hero-machines'),
    heroBatteries: document.getElementById('dsb-hero-batteries'),
    heroTstak: document.getElementById('dsb-hero-tstak'),

    batteriesStep: document.getElementById('dkb-batteries-step'),
    batteriesXr: document.getElementById('dkb-batteries-xr'),
    batteriesPowerstack: document.getElementById('dkb-batteries-powerstack'),
    batteriesFlexvolt: document.getElementById('dkb-batteries-flexvolt'),
    chargers: document.getElementById('dkb-chargers'),

    batterySelectedTop: document.getElementById('dkb-battery-selected-top'),
    batteryContinueTop: document.getElementById('dkb-battery-continue-top'),
    batteryContinueBottom: document.getElementById('dkb-battery-continue-bottom'),

    smartStep: document.getElementById('dkb-smart-step'),
    smartResult: document.getElementById('dkb-smart-result'),
    smartContinueBottom: document.getElementById('dkb-smart-continue-bottom'),

    tstakStep: document.getElementById('dkb-tstak-step'),
    tstakProducts: document.getElementById('dkb-tstak-products'),
    tstakSelectedTop: document.getElementById('dkb-tstak-selected-top'),
    tstakContinueTop: document.getElementById('dkb-tstak-continue-top'),
    tstakContinueBottom: document.getElementById('dkb-tstak-continue-bottom'),

    accessoriesStep: document.getElementById('dkb-accessories-step'),
    accessoriesProducts: document.getElementById('dkb-accessories-products'),
    accessoriesSelectedTop: document.getElementById('dkb-accessories-selected-top'),
    accessoriesFinishTop: document.getElementById('dkb-accessories-finish-top'),
    accessoriesFinishBottom: document.getElementById('dkb-accessories-finish-bottom')
  };

  let currentStep = 1;
  let selectedMachines = [];
  let machinesCache = [];

  let batteryCaches = {
    xr: [],
    powerstack: [],
    flexvolt: [],
    charger: []
  };

  let tstakCache = [];
  let accessoryCaches = {};

  let selectedBatteries = {};
  let selectedTstak = {};
  let selectedAccessories = {};
  let smartEngineResult = null;
  let selectedSmartChoice = 'optimized';
  let smartEngineTimer = null;
  let smartEngineRequestId = 0;

  const machineFamilies = [
    {
      key: 'trapani',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/trapani.jpg?v=1783674189',
      keywords: ['trapano', 'trapani']
    },
    {
      key: 'avvitatori',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/avvitatori.jpg?v=1783674150',
      keywords: ['avvitatore', 'avvitatori', 'impulsi']
    },
    {
      key: 'smerigliatrici',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/smeri.jpg?v=1783674181',
      keywords: ['smerigliatrice', 'smerigliatrici', 'angolare']
    },
    {
      key: 'seghe',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/seghe.jpg?v=1783674145',
      keywords: ['sega', 'seghe', 'seghetto', 'circolare']
    },
    {
      key: 'tassellatori',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/tassela.jpg?v=1783674165',
      keywords: ['tassellatore', 'tassellatori', 'martello']
    },
    {
      key: 'levigatrici',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/leviga.jpg?v=1783674157',
      keywords: ['levigatrice', 'levigatrici']
    },
    {
      key: 'altri',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/altri.jpg?v=1783674174',
      keywords: []
    }
  ];

  const accessoryFamilies = [
    {
      type: 'accessory_drill_bits',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/drill_bits.jpg?v=1783673935'
    },
    {
      type: 'accessory_screw_bits',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/scrwe_bits.jpg?v=1783673935'
    },
    {
      type: 'accessory_mixed_sets',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/mix_acs.jpg?v=1783673935'
    },
    {
      type: 'accessory_circular_blades',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/acs_seghe.jpg?v=1783673935'
    },
    {
      type: 'accessory_grinding_discs',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/acs_smerig.jpg?v=1783673935'
    },
    {
      type: 'accessory_sockets',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/acs_bussole.jpg?v=1783673934'
    },
    {
      type: 'accessory_other',
      image: 'https://cdn.shopify.com/s/files/1/0727/3021/4667/files/other.jpg?v=1783673934'
    }
  ];

  async function apiGet(path) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 45000);

    try {
      const res = await fetch(`${apiBase}${path}`, { signal: controller.signal, cache: 'no-store' });
      if (!res.ok) throw new Error(t('apiError', { status: res.status }));
      return await res.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        throw new Error(t('timeoutData'));
      }
      throw err;
    } finally {
      clearTimeout(timeout);
    }
  }

  async function apiPost(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 60000);

    try {
      const res = await fetch(`${apiBase}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal,
        cache: 'no-store'
      });

      if (!res.ok) throw new Error(t('apiError', { status: res.status }));
      return await res.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        throw new Error(t('timeoutSmart'));
      }
      throw err;
    } finally {
      clearTimeout(timeout);
    }
  }

  const money = (value) => {
    const locales = { it:'it-IT', fr:'fr-FR', de:'de-DE', es:'es-ES', en:'en-IE' };
    if (value === null || value === undefined || Number.isNaN(Number(value))) value = 0;
    return new Intl.NumberFormat(locales[locale] || 'it-IT', { style: 'currency', currency: 'EUR' }).format(Number(value));
  };

  function metafieldText(value) {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return String(value[0] || '').trim();

    const text = String(value).trim();

    // Shopify list.single_line_text_field is returned by GraphQL as
    // a JSON string such as: ["DEWALT DCD740NT-XJ ..."]
    if (text.startsWith('[')) {
      try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed)) return String(parsed[0] || '').trim();
      } catch (_) {}
    }

    return text;
  }

  function localizedProductTitle(product) {
    if (!product) return '';
    const translated = metafieldText(product[`title_${locale}`]);
    return translated || product.title || product.description || product.sku || '';
  }

  function cleanTitle(product) {
    const raw = localizedProductTitle(product);
    const sku = String(product?.sku || product?.machine || '').trim();
    return raw
      .replace(/^DEWALT\s+/i, '')
      .replace(sku ? new RegExp(sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : /$^/, '')
      .replace(/^[-–—:\s]+/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function localizedItemTitle(item) {
    if (!item) return '';
    const raw = metafieldText(item[`title_${locale}`]) || item.title || item.sku || '';
    const sku = String(item.sku || '').trim();
    return raw
      .replace(/^DEWALT\s+/i, '')
      .replace(sku ? new RegExp(sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : /$^/, '')
      .replace(/^[-–—:\s]+/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function productSku(product) {
    return product.sku || product.machine || '';
  }

  function isAvailable(product) {
    return Number(product.available_quantity || product.stock || 0) > 0;
  }

  function availableQty(product) {
    return Math.max(0, Number(product?.available_quantity || product?.stock || 0));
  }

  function productImage(product) {
    return product.image || product.featured_image || '';
  }

  function selectedMachineQty(sku) {
    return selectedMachines.filter(item => item === sku).length;
  }

  function selectedProducts() {
    return machinesCache
      .map(product => {
        const sku = productSku(product);
        const qty = selectedMachineQty(sku);
        return { ...product, qty };
      })
      .filter(product => product.qty > 0);
  }

  function selectedBatteryProducts() {
    const all = [
      ...batteryCaches.xr,
      ...batteryCaches.powerstack,
      ...batteryCaches.flexvolt,
      ...batteryCaches.charger
    ];

    return all
      .map(product => {
        const sku = productSku(product);
        const qty = selectedBatteries[sku] || 0;
        return { ...product, qty };
      })
      .filter(product => product.qty > 0);
  }

  function selectedTstakProducts() {
    return tstakCache
      .map(product => {
        const sku = productSku(product);
        const qty = selectedTstak[sku] || 0;
        return { ...product, qty };
      })
      .filter(product => product.qty > 0);
  }

  function selectedAccessoryProducts() {
    return Object.values(accessoryCaches)
      .flat()
      .map(product => {
        const sku = productSku(product);
        const qty = selectedAccessories[sku] || 0;
        return { ...product, qty };
      })
      .filter(product => product.qty > 0);
  }

  function machineFamily(product) {
    const text = `${product.title || ''} ${product.description || ''} ${product.sku || ''}`.toLowerCase();

    return machineFamilies.find(family =>
      family.key !== 'altri' &&
      family.keywords.some(keyword => text.includes(keyword))
    ) || machineFamilies.find(family => family.key === 'altri');
  }

  function selectedLabel(count) {
    if (count === 0) return t('noMachine');
    if (count === 1) return t('oneMachine');
    return t('manyMachines', { count });
  }

  function selectedBatteryLabel(count) {
    if (count === 0) return t('noBattery');
    if (count === 1) return t('oneItem');
    return t('manyItems', { count });
  }

  function selectedTstakLabel(count) {
    if (count === 0) return t('noTstak');
    if (count === 1) return t('oneTstak');
    return t('manyTstak', { count });
  }

  function selectedAccessoryLabel(count) {
    if (count === 0) return t('noAccessory');
    if (count === 1) return t('oneAccessory');
    return t('manyAccessories', { count });
  }

  function updateSteps() {
    document.querySelectorAll('.dsb-step').forEach((step, index) => {
      step.classList.toggle('is-active', index + 1 === currentStep);
      step.classList.toggle('is-complete', index + 1 < currentStep);
    });
  }

  let isScrubbingPublicLabels = false;
  let scrubTimer = null;

  function scrubPublicLabels() {
    if (isScrubbingPublicLabels) return;
    isScrubbingPublicLabels = true;

    const scope = document.body || root;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node = walker.nextNode();

    while (node) {
      nodes.push(node);
      node = walker.nextNode();
    }

    nodes.forEach(textNode => {
      const original = textNode.nodeValue || '';
      const updated = original
        .replace(/Stock Shopify live/gi, 'Disponibilità live')
        .replace(/stock Shopify live/gi, 'disponibilità live')
        .replace(/Shopify live/gi, 'disponibilità live')
        .replace(/stock Shopify/gi, 'disponibilità prodotti')
        .replace(/Stock Shopify/gi, 'Disponibilità prodotti')
        .replace(/Shopify/gi, '');

      if (updated !== original) {
        textNode.nodeValue = updated;
      }
    });

    isScrubbingPublicLabels = false;
  }

  function schedulePublicLabelScrub() {
    if (scrubTimer) clearTimeout(scrubTimer);
    scrubTimer = setTimeout(scrubPublicLabels, 50);
  }

  const publicLabelObserver = new MutationObserver(schedulePublicLabelScrub);
  publicLabelObserver.observe(document.body || root, { childList: true, subtree: true, characterData: true });

  function smartStepVisible() {
    return !!(els.smartStep && !els.smartStep.hidden);
  }

  function markSmartEngineDirty() {
    smartEngineResult = null;
    selectedSmartChoice = 'optimized';
    smartEngineRequestId += 1;

    if (smartEngineTimer) {
      clearTimeout(smartEngineTimer);
      smartEngineTimer = null;
    }

    if (els.smartContinueBottom) {
      els.smartContinueBottom.disabled = true;
    }

    if (els.add) {
      els.add.disabled = true;
    }

    if (els.smartResult && smartStepVisible()) {
      els.smartResult.innerHTML = `
        <div class="dkb-loading-box">
          <strong>⚙ Smart Engine</strong>
          <p>${t('recalculating')}</p>
        </div>
      `;

      if (selectedMachines.length) {
        smartEngineTimer = setTimeout(() => {
          runSmartEngine({ scroll: false });
        }, 500);
      }
    }
  }

  function customerSmartItems() {
    const machines = selectedProducts().map(product => ({
      sku: productSku(product),
      quantity: product.qty,
      title: cleanTitle(product) || product.title || productSku(product),
      price: Number(product.price || 0),
      line_price: Number(product.price || 0) * Number(product.qty || 0),
      group: 'machine'
    }));

    const batteries = selectedBatteryProducts().map(product => ({
      sku: productSku(product),
      quantity: product.qty,
      title: cleanTitle(product) || product.title || productSku(product),
      price: Number(product.price || 0),
      line_price: Number(product.price || 0) * Number(product.qty || 0),
      group: 'battery'
    }));

    return [...machines, ...batteries];
  }

  function renderSmartRows(items) {
    if (!items || !items.length) {
      return `<p class="dkb-smart-empty">${t('noProducts')}</p>`;
    }

    return items.map(item => `
      <div class="dkb-smart-item">
        <div>
          <strong>${item.quantity}× ${item.sku}</strong>
          <span>${localizedItemTitle(item) || item.sku}</span>
        </div>
        <strong>${money(item.line_price)}</strong>
      </div>
    `).join('');
  }

  function renderSmartExtraRows(items) {
    if (!items || !items.length) return '';

    return items.map(item => `
      <div class="dkb-smart-extra-item">
        <strong>${item.quantity}× ${item.sku}</strong>
        <span>${t('includedKit')}</span>
      </div>
    `).join('');
  }


  function getSmartCartItems() {
    if (!smartEngineResult) return [];

    const hasOptimization = !!(
      smartEngineResult.optimization &&
      Number(smartEngineResult.saving || 0) > 0
    );

    if (hasOptimization && selectedSmartChoice === 'customer') {
      return Array.isArray(smartEngineResult.customer_add_to_cart_items)
        ? smartEngineResult.customer_add_to_cart_items
        : [];
    }

    return Array.isArray(smartEngineResult.add_to_cart_items)
      ? smartEngineResult.add_to_cart_items
      : [];
  }

  function productToCartItem(product) {
    const id = Number(product.variant_id || product.id || 0);
    const quantity = Number(product.qty || product.quantity || 0);

    if (!id || quantity <= 0) return null;

    return { id, quantity };
  }

  function getExtraCartItems() {
    return [
      ...selectedTstakProducts(),
      ...selectedAccessoryProducts()
    ]
      .map(productToCartItem)
      .filter(Boolean);
  }

  function mergeCartItems(items) {
    const merged = new Map();

    (items || []).forEach(item => {
      const id = Number(item.id || item.variant_id || 0);
      const quantity = Number(item.quantity || item.qty || 0);

      if (!id || quantity <= 0) return;

      merged.set(id, (merged.get(id) || 0) + quantity);
    });

    return Array.from(merged.entries()).map(([id, quantity]) => ({ id, quantity }));
  }

  function buildCartItems() {
    return mergeCartItems([
      ...getSmartCartItems(),
      ...getExtraCartItems()
    ]);
  }

  function setCartBusy(isBusy) {
    const buttons = [
      els.add,
      els.accessoriesFinishTop,
      els.accessoriesFinishBottom
    ].filter(Boolean);

    buttons.forEach(button => {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent;
      }

      button.disabled = isBusy || button.disabled;
      button.classList.toggle('is-cart-loading', isBusy);

      if (isBusy) {
        button.textContent = t('addBusy');
      } else {
        button.textContent = button.dataset.originalText;
      }
    });
  }

  async function addItemsToShopifyCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      let message = t('addFail');

      try {
        const error = await res.json();
        message = error.description || error.message || message;
      } catch (_) {}

      throw new Error(message);
    }

    return await res.json();
  }

  function showCartError(message) {
    const errorHtml = `<div class="dkb-error">${message}</div>`;

    if (els.smartResult && smartStepVisible()) {
      els.smartResult.insertAdjacentHTML('beforeend', errorHtml);
    } else {
      alert(message);
    }
  }

  function changeMachineQty(sku, delta) {
    const cleanSku = String(sku || '').trim().toUpperCase();
    const product = machinesCache.find(item => productSku(item) === cleanSku);
    const maxQty = availableQty(product);
    const currentQty = selectedMachineQty(cleanSku);
    const nextQty = Math.max(0, Math.min(maxQty || 99, currentQty + delta));

    selectedMachines = selectedMachines.filter(item => item !== cleanSku);

    for (let index = 0; index < nextQty; index += 1) {
      selectedMachines.push(cleanSku);
    }

    markSmartEngineDirty();
    renderMachines();
    renderSidebar();
  }

  function renderMachines() {
    const grouped = {};

    machineFamilies.forEach(family => {
      grouped[family.key] = [];
    });

    machinesCache.forEach(product => {
      const family = machineFamily(product);
      grouped[family.key].push(product);
    });

    els.machines.innerHTML = machineFamilies
      .filter(family => grouped[family.key].length > 0)
      .map(family => {
        const cards = grouped[family.key].map(product => {
          const sku = productSku(product);
          const qty = selectedMachineQty(sku);
          const selected = qty > 0;
          const available = isAvailable(product);
          const availableQtyValue = availableQty(product);
          const image = productImage(product);
          const title = cleanTitle(product) || product.description || sku;

          return `
            <div class="dkb-card dkb-machine-card ${selected ? 'is-selected is-qty-selected' : ''}" data-machine-card="${sku}">
              <div class="dkb-card-image-placeholder">
                ${image ? `<img src="${image}" alt="${sku}" loading="lazy">` : `<span>DEWALT</span>`}
              </div>

              <div class="dkb-card-content">
                <strong>${sku}</strong>
                <span>${title}</span>

                <div class="dkb-card-meta">
                  <small>TSTAK inclusa</small>
                  <b>${money(product.price || 0)}</b>
                </div>

                <div class="dkb-availability">
                  <i class="dkb-dot ${available ? 'dkb-dot--green' : 'dkb-dot--red'}"></i>
                  <b>${available ? t('available') : t('unavailable')}</b>
                </div>

                <div class="dkb-qty-control dkb-machine-qty-control">
                  <button type="button" data-machine-minus="${sku}" ${qty <= 0 ? 'disabled' : ''}>−</button>
                  <strong>${qty}</strong>
                  <button type="button" data-machine-plus="${sku}" ${!available || (availableQtyValue && qty >= availableQtyValue) ? 'disabled' : ''}>+</button>
                </div>
              </div>
            </div>
          `;
        }).join('');

        return `
          <div class="dkb-machine-family">
            <div class="dkb-machine-family-separator">
              <span></span>
              <img src="${family.image}" alt="${family.key}">
              <span></span>
            </div>

            <div class="dkb-machine-family-grid">
              ${cards}
            </div>
          </div>
        `;
      }).join('');

    els.machines.querySelectorAll('[data-machine-minus]').forEach(btn => {
      btn.addEventListener('click', event => {
        event.stopPropagation();
        changeMachineQty(btn.dataset.machineMinus, -1);
      });
    });

    els.machines.querySelectorAll('[data-machine-plus]').forEach(btn => {
      btn.addEventListener('click', event => {
        event.stopPropagation();
        changeMachineQty(btn.dataset.machinePlus, 1);
      });
    });
  }

  function renderQtyGroup(container, products, selectedMap, type) {
    container.innerHTML = products.map(product => {
      const sku = productSku(product);
      const qty = selectedMap[sku] || 0;
      const available = isAvailable(product);
      const availableQtyValue = availableQty(product);
      const image = productImage(product);
      const title = cleanTitle(product) || product.description || sku;

      return `
        <div class="dkb-card dkb-battery-card ${qty > 0 ? 'is-qty-selected' : ''}">
          <div class="dkb-card-image-placeholder">
            ${image ? `<img src="${image}" alt="${sku}" loading="lazy">` : `<span>DEWALT</span>`}
          </div>

          <div class="dkb-card-content">
            <strong>${sku}</strong>
            <span>${title}</span>

            <div class="dkb-card-meta">
              <small>${product.system_builder_type || type}</small>
              <b>${money(product.price || 0)}</b>
            </div>

            <div class="dkb-availability">
              <i class="dkb-dot ${available ? 'dkb-dot--green' : 'dkb-dot--red'}"></i>
              <b>${available ? t('available') : t('unavailable')}</b>
            </div>

            <div class="dkb-qty-control">
              <button type="button" data-qty-minus="${sku}" data-type="${type}" ${qty <= 0 ? 'disabled' : ''}>−</button>
              <strong>${qty}</strong>
              <button type="button" data-qty-plus="${sku}" data-type="${type}" ${!available || (availableQtyValue && qty >= availableQtyValue) ? 'disabled' : ''}>+</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    container.querySelectorAll('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const sku = btn.dataset.qtyMinus;

        if (type === 'tstak') {
          selectedTstak[sku] = Math.max(0, (selectedTstak[sku] || 0) - 1);
          renderTstak();
        } else if (type === 'accessory') {
          selectedAccessories[sku] = Math.max(0, (selectedAccessories[sku] || 0) - 1);
          renderAccessories();
        } else {
          selectedBatteries[sku] = Math.max(0, (selectedBatteries[sku] || 0) - 1);
          markSmartEngineDirty();
          renderBatteries();
        }

        renderSidebar();
      });
    });

    container.querySelectorAll('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const sku = btn.dataset.qtyPlus;
        const product = products.find(item => productSku(item) === sku);
        const maxQty = availableQty(product);

        if (!product || maxQty <= 0) return;

        if (type === 'tstak') {
          const currentQty = selectedTstak[sku] || 0;
          selectedTstak[sku] = Math.min(maxQty, currentQty + 1);
          renderTstak();
        } else if (type === 'accessory') {
          const currentQty = selectedAccessories[sku] || 0;
          selectedAccessories[sku] = Math.min(maxQty, currentQty + 1);
          renderAccessories();
        } else {
          const currentQty = selectedBatteries[sku] || 0;
          selectedBatteries[sku] = Math.min(maxQty, currentQty + 1);
          markSmartEngineDirty();
          renderBatteries();
        }

        renderSidebar();
      });
    });
  }

  function renderBatteries() {
    renderQtyGroup(els.batteriesXr, batteryCaches.xr, selectedBatteries, 'battery');
    renderQtyGroup(els.batteriesPowerstack, batteryCaches.powerstack, selectedBatteries, 'battery');
    renderQtyGroup(els.batteriesFlexvolt, batteryCaches.flexvolt, selectedBatteries, 'battery');
    renderQtyGroup(els.chargers, batteryCaches.charger, selectedBatteries, 'battery');
  }

  function renderTstak() {
    renderQtyGroup(els.tstakProducts, tstakCache, selectedTstak, 'tstak');
  }

  function renderAccessories() {
    els.accessoriesProducts.innerHTML = accessoryFamilies
      .filter(family => (accessoryCaches[family.type] || []).length > 0)
      .map(family => {
        const containerId = `dkb-accessory-${family.type}`;

        return `
          <div class="dkb-accessory-family">
            <div class="dkb-accessory-family-separator">
              <span></span>
              <img src="${family.image}" alt="${family.type}">
              <span></span>
            </div>

            <div id="${containerId}" class="dkb-accessory-family-grid"></div>
          </div>
        `;
      }).join('') || `<p>${t('noAccessoriesNow')}</p>`;

    accessoryFamilies.forEach(family => {
      const container = document.getElementById(`dkb-accessory-${family.type}`);
      if (container) {
        renderQtyGroup(container, accessoryCaches[family.type] || [], selectedAccessories, 'accessory');
      }
    });
  }

  function renderSidebar() {
    const machines = selectedProducts();
    const batteries = selectedBatteryProducts();
    const tstak = selectedTstakProducts();
    const accessories = selectedAccessoryProducts();

    const machineTotal = machines.reduce((sum, p) => sum + (Number(p.price || 0) * Number(p.qty || 0)), 0);
    const batteryTotal = batteries.reduce((sum, p) => sum + (Number(p.price || 0) * p.qty), 0);
    const tstakTotal = tstak.reduce((sum, p) => sum + (Number(p.price || 0) * p.qty), 0);
    const accessoriesTotal = accessories.reduce((sum, p) => sum + (Number(p.price || 0) * p.qty), 0);

    const baseTotal = machineTotal + batteryTotal;
    const hasSmartOptimization = !!(
      smartEngineResult &&
      smartEngineResult.optimization &&
      Number(smartEngineResult.saving || 0) > 0
    );
    const smartEngineSubtotal = smartEngineResult
      ? (
          hasSmartOptimization && selectedSmartChoice === 'customer'
            ? Number(smartEngineResult.base_price || baseTotal)
            : Number(smartEngineResult.price || baseTotal)
        )
      : baseTotal;
    const total = smartEngineSubtotal + tstakTotal + accessoriesTotal;

    const machineCount = machines.reduce((sum, p) => sum + Number(p.qty || 0), 0);
    const batteryQty = batteries.reduce((sum, p) => sum + p.qty, 0);
    const tstakQty = tstak.reduce((sum, p) => sum + p.qty, 0);
    const accessoriesQty = accessories.reduce((sum, p) => sum + p.qty, 0);

    if (els.selectedTop) els.selectedTop.textContent = selectedLabel(machineCount);
    if (els.heroMachines) els.heroMachines.textContent = machineCount;
    if (els.heroBatteries) els.heroBatteries.textContent = batteryQty;
    if (els.heroTstak) els.heroTstak.textContent = tstakQty;
    if (els.batterySelectedTop) els.batterySelectedTop.textContent = selectedBatteryLabel(batteryQty);
    if (els.tstakSelectedTop) els.tstakSelectedTop.textContent = selectedTstakLabel(tstakQty);
    if (els.accessoriesSelectedTop) els.accessoriesSelectedTop.textContent = selectedAccessoryLabel(accessoriesQty);

    if (els.continueTop) els.continueTop.disabled = machineCount === 0;
    if (els.continueBottom) els.continueBottom.disabled = machineCount === 0;
    if (els.batteryContinueTop) els.batteryContinueTop.disabled = machineCount === 0;
    if (els.batteryContinueBottom) els.batteryContinueBottom.disabled = machineCount === 0;

    const machineList = machines.length
      ? machines.map(product => `
          <div class="dkb-selected-product">
            <strong>${product.qty}× ${productSku(product)}</strong>
            <span>${cleanTitle(product) || product.title}</span>
          </div>
        `).join('')
      : `<span>${t('noMachineDot')}</span>`;

    const batteryList = batteries.length
      ? batteries.map(product => `
          <div class="dkb-selected-product">
            <strong>${product.qty}× ${productSku(product)}</strong>
            <span>${cleanTitle(product) || product.title}</span>
          </div>
        `).join('')
      : `<span>${t('noBatteryDot')}</span>`;

    const tstakList = tstak.length
      ? tstak.map(product => `
          <div class="dkb-selected-product">
            <strong>${product.qty}× ${productSku(product)}</strong>
            <span>${cleanTitle(product) || product.title}</span>
          </div>
        `).join('')
      : `<span>${t('noTstakDot')}</span>`;

    const accessoriesList = accessories.length
      ? accessories.map(product => `
          <div class="dkb-selected-product">
            <strong>${product.qty}× ${productSku(product)}</strong>
            <span>${cleanTitle(product) || product.title}</span>
          </div>
        `).join('')
      : `<span>${t('noAccessoryDot')}</span>`;

    els.selection.innerHTML = `
      <div class="dkb-summary-row">
        <strong>Macchine selezionate (${machineCount})</strong>
        ${machineList}
      </div>
    `;

    els.solution.innerHTML = `
      <div class="dkb-summary-row">
        <strong>Batterie e caricabatterie (${batteryQty})</strong>
        ${batteryList}
      </div>

      <div class="dkb-summary-row">
        <strong>Sistema TSTAK (${tstakQty})</strong>
        ${tstakList}
      </div>

      <div class="dkb-summary-row">
        <strong>Accessori (${accessoriesQty})</strong>
        ${accessoriesList}
      </div>

      <div class="dkb-summary-row">
        <strong>Smart Engine</strong>
        <span>${smartEngineResult ? (
          hasSmartOptimization
            ? (selectedSmartChoice === 'customer'
                ? t('customerSelected')
                : smartEngineResult.message)
            : smartEngineResult.message
        ) : t('waitingSmart')}</span>
      </div>

      <div class="dkb-total-box">
        <span>${smartEngineResult ? (selectedSmartChoice === 'customer' ? t('customerPrice') : t('verifiedPrice')) : t('provisionalPrice')}</span>
        <strong>${money(total)}</strong>
        <small>${t('vat')}</small>
      </div>
    `;

    const activeSmartAvailable = smartEngineResult
      ? (
          hasSmartOptimization && selectedSmartChoice === 'customer'
            ? smartEngineResult.base_available !== false
            : smartEngineResult.available
        )
      : false;

    els.add.disabled = !activeSmartAvailable;
  }

  function renderSmartEngine(result) {
    smartEngineResult = result;

    const baseItems = (result.base_items && result.base_items.length)
      ? result.base_items
      : customerSmartItems();

    const customerCalculatedTotal = baseItems.reduce((sum, item) => sum + Number(item.line_price || 0), 0);
    const customerTotal = Number(result.base_price || customerCalculatedTotal || 0);
    const optimizedTotal = Number(result.price || 0);
    const saving = Number(result.saving || Math.max(0, customerTotal - optimizedTotal));
    const hasOptimization = !!(result.optimization && saving > 0);

    if (!hasOptimization) {
      selectedSmartChoice = 'customer';
    }

    const selectedTotal = hasOptimization && selectedSmartChoice === 'optimized'
      ? optimizedTotal
      : customerTotal;

    const selectedAvailable = hasOptimization && selectedSmartChoice === 'optimized'
      ? result.available
      : result.base_available !== false;

    const statusText = selectedAvailable
      ? (hasOptimization ? t('optAvailable') : t('configAvailable'))
      : t('incomplete');

    const optimizedTitle = hasOptimization
      ? t('recommended')
      : t('verified');

    const extraIncluded = Array.isArray(result.extra_included) ? result.extra_included : [];
    const extraText = extraIncluded.length
      ? t('extraSentence')
      : '';

    const smartMessage = hasOptimization
      ? t('better', { saving: money(saving), extra: extraText })
      : result.message;

    els.smartResult.innerHTML = `
      <div class="dkb-smart-status ${selectedAvailable ? 'dkb-smart-status--ok' : 'dkb-smart-status--ko'}">
        ${statusText}
      </div>

      <p>${smartMessage}</p>

      <div class="dkb-smart-comparison">
        <div class="dkb-smart-column dkb-smart-column--customer ${selectedSmartChoice === 'customer' ? 'is-smart-choice-active' : ''}">
          <div class="dkb-smart-column-header">
            <span>${t('customerConfig')}</span>
            <strong>${money(customerTotal)}</strong>
          </div>
          <div class="dkb-smart-items">
            ${renderSmartRows(baseItems)}
          </div>
          ${hasOptimization ? `
            <div class="dkb-smart-choice-footer">
              <button
                type="button"
                class="dkb-smart-choice-button ${selectedSmartChoice === 'customer' ? 'is-active' : ''}"
                data-smart-choice="customer"
                ${result.base_available === false ? 'disabled' : ''}
              >
                ${t('useThis')}
              </button>
            </div>
          ` : ''}
        </div>

        <div class="dkb-smart-column ${hasOptimization ? 'dkb-smart-column--optimized' : 'dkb-smart-column--verified'} ${selectedSmartChoice === 'optimized' ? 'is-smart-choice-active' : ''}">
          <div class="dkb-smart-column-header">
            <span>${optimizedTitle}</span>
            <strong>${money(optimizedTotal)}</strong>
          </div>
          <div class="dkb-smart-items">
            ${renderSmartRows(result.items)}
          </div>
          ${hasOptimization ? `
            <div class="dkb-smart-choice-footer">
              <button
                type="button"
                class="dkb-smart-choice-button ${selectedSmartChoice === 'optimized' ? 'is-active' : ''}"
                data-smart-choice="optimized"
                ${!result.available ? 'disabled' : ''}
              >
                ${t('useRecommended')}
              </button>
            </div>
          ` : ''}
        </div>
      </div>

      ${hasOptimization && extraIncluded.length ? `
        <div class="dkb-smart-extra-box">
          <div>
            <strong>${t('extraTitle')}</strong>
            <span>${t('extraSub')}</span>
          </div>
          <div class="dkb-smart-extra-list">
            ${renderSmartExtraRows(extraIncluded)}
          </div>
        </div>
      ` : ''}

      ${hasOptimization ? `
        <div class="dkb-smart-saving-box">
          <strong>${t('saving')}</strong>
          <span>${money(saving)}</span>
        </div>
      ` : ''}

      <div class="dkb-smart-total">
        <span>${selectedSmartChoice === 'customer' ? t('customerTotal') : t('verifiedTotal')}</span>
        <strong>${money(selectedTotal)}</strong>
        <small>${t('vat')}</small>
      </div>
    `;

    els.smartResult.querySelectorAll('[data-smart-choice]').forEach(button => {
      button.addEventListener('click', () => {
        selectedSmartChoice = button.dataset.smartChoice === 'customer' ? 'customer' : 'optimized';
        renderSmartEngine(smartEngineResult);
        renderSidebar();
      });
    });

    if (els.smartContinueBottom) {
      els.smartContinueBottom.disabled = !selectedAvailable;
    }

    renderSidebar();
  }

  async function loadMachines() {
    try {
      els.machines.innerHTML = `<p>${t('loadingMachines')}</p>`;
      const data = await apiGet('/api/shopify-builder-products?type=machine&vendor=DEWALT');
      if (!Array.isArray(data)) {
        throw new Error(t('invalidMachines'));
      }
      machinesCache = data;
      renderMachines();
      renderSidebar();
      schedulePublicLabelScrub();
    } catch (err) {
      console.error('Errore caricamento macchine', err);
      els.machines.innerHTML = `<p class="dkb-error">${err.message}</p>`;
    }
  }

  async function apiGetWithRetry(path, attempts = 3) {
    let lastError;

    for (let attempt = 1; attempt <= attempts; attempt += 1) {
      try {
        return await apiGet(path);
      } catch (err) {
        lastError = err;
        if (attempt < attempts) {
          await new Promise(resolve => setTimeout(resolve, 700 * attempt));
        }
      }
    }

    throw lastError;
  }

  async function loadBatteries() {
    const groups = [
      ['xr', els.batteriesXr, '/api/shopify-builder-products?type=xr&vendor=DEWALT'],
      ['powerstack', els.batteriesPowerstack, '/api/shopify-builder-products?type=powerstack&vendor=DEWALT'],
      ['flexvolt', els.batteriesFlexvolt, '/api/shopify-builder-products?type=flexvolt&vendor=DEWALT'],
      ['charger', els.chargers, '/api/shopify-builder-products?type=charger&vendor=DEWALT']
    ];

    for (const [key, container, path] of groups) {
      try {
        batteryCaches[key] = await apiGetWithRetry(path);
        renderQtyGroup(container, batteryCaches[key], selectedBatteries, 'battery');
      } catch (err) {
        console.error(`Errore caricamento ${key}`, err);
        container.innerHTML = `<p class="dkb-error">${err.message}</p>`;
      }

      // Evita 4 richieste Shopify simultanee al backend.
      await new Promise(resolve => setTimeout(resolve, 250));
    }

    renderSidebar();
  }

  async function loadTstak() {
    try {
      els.tstakProducts.innerHTML = `<p>${t('loadingTstak')}</p>`;
      tstakCache = await apiGet('/api/shopify-builder-products?type=tstak&vendor=DEWALT');
      renderTstak();
      renderSidebar();
    } catch (err) {
      els.tstakProducts.innerHTML = `<p class="dkb-error">${err.message}</p>`;
    }
  }

  async function loadAccessories() {
    els.accessoriesProducts.innerHTML = `<p>${t('loadingAccessories')}</p>`;

    const results = await Promise.allSettled(
      accessoryFamilies.map(family => apiGet(`/api/shopify-builder-products?type=${family.type}&vendor=DEWALT`))
    );

    accessoryFamilies.forEach((family, index) => {
      if (results[index].status === 'fulfilled' && Array.isArray(results[index].value)) {
        accessoryCaches[family.type] = results[index].value;
      } else {
        accessoryCaches[family.type] = [];
        console.warn(`Accessori non caricati per ${family.type}`, results[index].reason);
      }
    });

    renderAccessories();
    renderSidebar();
  }

  function goToBatteries() {
    if (!selectedMachines.length) return;

    currentStep = 2;
    updateSteps();

    els.batteriesStep.hidden = false;
    els.batteriesStep.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (!batteryCaches.xr.length && !batteryCaches.powerstack.length && !batteryCaches.flexvolt.length && !batteryCaches.charger.length) {
      loadBatteries();
    }
  }

  async function runSmartEngine({ scroll = false } = {}) {
    if (!selectedMachines.length) return;

    currentStep = 3;
    updateSteps();

    els.smartStep.hidden = false;

    if (scroll) {
      els.smartStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    const requestId = smartEngineRequestId + 1;
    smartEngineRequestId = requestId;

    els.smartResult.innerHTML = `
      <div class="dkb-loading-box">
        <strong>⚙ Smart Engine</strong>
        <p>${t('analyzing')}</p>
      </div>
    `;

    try {
      const machines = selectedProducts().map(product => ({
        sku: productSku(product),
        qty: product.qty
      }));
      const batteries = selectedBatteryProducts().map(product => ({
        sku: productSku(product),
        qty: product.qty
      }));

      const result = await apiPost('/api/smart-engine', {
        machines,
        batteries
      });

      if (requestId !== smartEngineRequestId) return;

      renderSmartEngine(result);

    } catch (err) {
      if (requestId !== smartEngineRequestId) return;
      els.smartResult.innerHTML = `<div class="dkb-error">${err.message}</div>`;
    }
  }

  async function goToSmartEngine() {
    runSmartEngine({ scroll: true });
  }

  function goToTstak() {
    currentStep = 4;
    updateSteps();

    els.tstakStep.hidden = false;
    els.tstakStep.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (!tstakCache.length) {
      loadTstak();
    }
  }

  function goToAccessories() {
    currentStep = 5;
    updateSteps();

    els.accessoriesStep.hidden = false;
    els.accessoriesStep.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (!Object.keys(accessoryCaches).length) {
      loadAccessories();
    }
  }

  async function goToFinalCart() {
    if (!smartEngineResult) {
      showCartError(t('completeSmart'));
      return;
    }

    const items = buildCartItems();

    if (!items.length) {
      showCartError(t('noValid'));
      return;
    }

    try {
      setCartBusy(true);
      await addItemsToShopifyCart(items);
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (err) {
      console.error('Errore aggiunta al carrello', err);
      showCartError(err.message || t('cartErr'));
      setCartBusy(false);
      renderSidebar();
    }
  }

  els.continueTop.addEventListener('click', goToBatteries);
  els.continueBottom.addEventListener('click', goToBatteries);

  els.batteryContinueTop.addEventListener('click', goToSmartEngine);
  els.batteryContinueBottom.addEventListener('click', goToSmartEngine);

  els.smartContinueBottom.addEventListener('click', goToTstak);
  els.tstakContinueTop.addEventListener('click', goToAccessories);
  els.tstakContinueBottom.addEventListener('click', goToAccessories);

  els.accessoriesFinishTop.addEventListener('click', goToFinalCart);
  els.accessoriesFinishBottom.addEventListener('click', goToFinalCart);

  els.add.addEventListener('click', goToFinalCart);

  updateSteps();
  scrubPublicLabels();
  loadMachines();
})();